export const Consts = {
    waitTime: 11,
    idleAfter: 900,
    logoutAfterIdle: 300,
    keepAliveInterval: 600,
    loadingMessage: 'Loading Data',
    searchingMessage: 'Searching',
    copyingMessage: 'Copying',
    serverlUrl: '/',
    tooManyTableCellLimit: 500,
    tableCellCountSlowSubmit: 4000,
    maxTableCellLimit: 13000,

    ENABLE_SYNTHESIS: false,

    // For each rest service
    LOGIN_URL: 'login',
    RESET_PASSWORD_URL: 'rest/userself/resetpwd',
    SAVE_RESET_PASSWORD_URL: 'rest/userself/savepwd',
    QUERY_RESET_PASSWORD_ACCOUNT_TYPE: 'rest/userself/accounttype',
    QUERY_LOGOUT: 'logout',
    QUERY_SAMPLE_EXPORT_JSON: '/rest/sample/fullSampleExportJsonAll',
    QUERY_SAMPLE_EXPORT_XML: '/rest/sample/fullSampleExportXmlAll',
    QUERY_GET_TABS: '/rest/core/getTabs',
    QUERY_ADMIN_SEARCH_USERS: '/rest/useraccount/search',
    QUERY_ADMIN_RESET_PASSWORD: '/rest/useraccount/resetpwd',
    QUERY_ADMIN_USER_CREATE: '/rest/useraccount/create',
    QUERY_ADMIN_USER_READ: '/rest/useraccount/read',
    QUERY_ADMIN_USER_UPDATE: '/rest/useraccount/update',
    QUERY_CURATION_REVIEW_DATA: '/rest/curation/reviewData',
    QUERY_CURATION_RESULTS: '/rest/curation/manageResult',
    QUERY_CURATION_GENERATE_BATCH_AVAILABILITY: '/rest/curation/generateBatchDataAvailability',
    QUERY_COLLABORATION_GET_GROUPS: '/rest/community/getCollaborationGroups',
    QUERY_COLLABORATION_SETUP_NEW: '/rest/community/setupNew',
    QUERY_COLLABORATION_DELETE_GROUPS: '/rest/community/deleteCollaborationGroups',
    QUERY_COLLABORATION_EDIT_GROUP: '/rest/community/editCollaborationGroup',
    QUERY_COLLABORATION_DELETE_USER_ACCESS: '/rest/community/deleteUserAccess',
    QUERY_COLLABORATION_ADD_USER_ACCESS: '/rest/community/addUserAccess',
    QUERY_COLLABORATION_GET_SAMPLES: '/rest/community/getsamples',
    QUERY_COLLABORATION_ADD_COLLABORATION_GROUPS: '/rest/community/addCollaborationGroups',
    QUERY_SEARCH: '/rest/customsearch/search',
    QUERY_INIT_SETUP: '/rest/core/initSetup',
    QUERY_GET_USER_GROUPS: '/rest/security/getUserGroups',
    QUERY_GET_COLLABORATION_GROUPS: '/rest/core/getCollaborationGroup',
    QUERY_GET_USERS: '/rest/core/getUsers',
    SAVE_COMPOSING_ELEMENT: '/rest/nanomaterialEntity/saveComposingElement',

    QUERY_SAMPLE_SEARCH_BY_PUB: '/rest/publication/searchById',
    QUERY_SAMPLE_GET_NAMES: '/rest/sample/getSampleNames',
    QUERY_SAMPLE_GET_SAMPLE_NAME: '/rest/sample/getCurrentSampleName',
    QUERY_SAMPLE_COPY: '/rest/sample/copySample',
    QUERY_SAMPLE_EDIT: '/rest/sample/edit',
    QUERY_SAMPLE_VIEW: '/rest/sample/view',
    QUERY_SAMPLE_SUBMIT: '/rest/sample/submitSample',
    QUERY_SAMPLE_SUBMISSION_SETUP: '/rest/sample/submissionSetup',
    QUERY_SAMPLE_SUBMIT_REVIEW: '/rest/sample/submitForReview',
    QUERY_SAMPLE_SETUP: '/rest/sample/setup',
    QUERY_SAMPLE_DELETE_FROM_WORKSPACE: '/rest/sample/deleteSampleFromWorkspace',
    QUERY_SAMPLE_ADVANCED_SEARCH_SETUP: '/rest/sample/setupAdvancedSearch',
    QUERY_SAMPLE_ADVANCED_SEARCH: '/rest/sample/searchSampleAdvanced',
    QUERY_SEARCH_SAMPLE: '/rest/sample/searchSample', // @TODO rename this SAMPLE_SEARCH
    QUERY_SAMPLE_AVAILABILITY: '/rest/sample/regenerateDataAvailability',
    QUERY_SAMPLE_VIEW_AVAILABILITY: '/rest/sample/viewDataAvailability',
    QUERY_SAMPLE_DELETE_AVAILABILITY: '/rest/sample/deleteDataAvailability',
    QUERY_SAMPLE_DELETE_ACCESS: '/rest/sample/deleteAccess',
    QUERY_SAMPLE_SAVE_ACCESS: '/rest/sample/saveAccess',
    QUERY_SAMPLE_DELETE: '/rest/sample/deleteSample',
    QUERY_SAMPLE_UPDATE: '/rest/sample/updateSample',
    QUERY_SAMPLE_AVAILABILITY_HTML: 'views/sample/view/sampleDataAvailability.html',  // @FIXME That's not how this works
    QUERY_SAMPLE_POC_UPDATE_SAVE:  '/rest/sample/savePOC',
    QUERY_SAMPLE_POC_UPDATE_DELETE: '/rest/sample/deletePOC',
    QUERY_SAMPLE_GET_CHARACTERIZATION_OPTIONS:  '/rest/sample/getDecoratedCharacterizationOptions',
    QUERY_SAMPLE_GET_DATUM_OPTIONS:  '/rest/sample/getDecoratedDatumOptions',
    QUERY_SAMPLE_GET_DATUM_UNIT_OPTIONS:  '/rest/sample/getDatumUnitOptions',
    QUERY_SAMPLE_WRITE_ACCESS: '/rest/sample/checkWriteAccess',

    QUERY_NANOMATERIAL_UPDATE: '/rest/nanomaterialEntity/submit',
    QUERY_NANOMATERIAL_EDIT: '/rest/nanomaterialEntity/edit',
    QUERY_NANOMATERIAL_SETUP: '/rest/nanomaterialEntity/setup',
    QUERY_NANOMATERIAL_DELETE: '/rest/nanomaterialEntity/delete',
    QUERY_NANOMATERIAL_SAVE_FILE: '/rest/nanomaterialEntity/saveFile',
    QUERY_NANOMATERIAL_REMOVE_FILE: '/rest/nanomaterialEntity/removeFile',
    QUERY_PROTOCOL_SETUP: '/rest/protocol/setup',
    QUERY_PROTOCOL_SAVE_ACCESS: '/rest/protocol/saveAccess',
    QUERY_PROTOCOL_SUBMIT_REVIEW: '/rest/protocol/submitForReview',
    QUERY_SEARCH_PROTOCOL: '/rest/protocol/searchProtocol',
    QUERY_DELETE_PROTOCOL: '/rest/protocol/deleteProtocol',
    QUERY_DELETE_PROTOCOL_BY_ID: '/rest/protocol/deleteProtocolById',
    QUERY_DELETE_PUBLICATION_BY_ID: '/rest/publication/deletePublicationById',
    QUERY_REMOVE_COMPOSING_ELEMENT: '/rest/nanomaterialEntity/removeComposingElement',
    QUERY_CREATE_PROTOCOL: '/rest/protocol/submitProtocol',
    QUERY_UPDATE_PROTOCOL: '/rest/protocol/submitProtocol', // SAME AS create
    QUERY_EDIT_PROTOCOL: '/rest/protocol/edit',
    QUERY_VIEW_PROTOCOL: '/rest/protocol/view',
    QUERY_GET_PROTOCOL: '/rest/protocol/getProtocol',
    QUERY_PROTOCOL_WRITE_ACCESS: 'rest/protocol/checkWriteAccess',
    QUERY_PROTOCOL_DELETE_ACCESS: '/rest/protocol/deleteAccess',
    QUERY_DOWNLOAD_FILE: '/rest/protocol/download',
    QUERY_PUBLICATION_DOWNLOAD_FILE: '/',
    QUERY_PUBLICATION_SUBMIT_REVIEW: '/rest/publication/submitForReview',
    QUERY_PUBLICATION_SETUP: '/rest/publication/setup',
    QUERY_PUBLICATION_SAVE: '/rest/publication/submitPublication',
    QUERY_PUBLICATION_SEARCH: '/rest/publication/searchPublication',
    QUERY_SAMPLE_SEARCH_BY_PUBLICATION: '/rest/publication/searchById',
    QUERY_PUBLICATION_SUMMARY_VIEW: '/rest/publication/summaryView',
    QUERY_PUBLICATION_EDIT: '/rest/publication/edit',
    QUERY_PUBLICATION_WRITE_ACCESS: 'rest/publication/checkWriteAccess',
    QUERY_PUBLICATION_DELETE: '/rest/publication/deletePublication',
    QUERY_PUBLICATION_DELETE_ACCESS: '/rest/publication/deleteAccess',
    QUERY_PUBLICATION_SAVE_ACCESS: '/rest/publication/saveAccess',
    QUERY_PUBLICATION_GET_PUBMED_INFO: '/rest/publication/retrievePubMedInfo',
    QUERY_PUBLICATION_GET_SAMPLES: '/rest/publication/getSamples',
    QUERY_PUBLICATION_GET_PUBMED_PUBLICATION: '/rest/publication/getPubmedPublication',
    QUERY_PUBLICATION_EXPORT_XLS: '/rest/publication/summaryExport',
    QUERY_PUBLICATION_DOWNLOAD: '/rest/publication/download',
    QUERY_UPLOAD_FILE: '/rest/core/uploadFile',
    QUERY_CHARACTERIZATION_VIEW: '/rest/sample/characterizationView',
    QUERY_GET_CHARACTERIZATION_BY_TYPE: '/rest/sample/getCharacterizationByType',
    QUERY_CHARACTERIZATION_SETUP_ADD: '/rest/characterization/setupAdd',
    QUERY_CHARACTERIZATION_SETUP_EDIT: '/rest/characterization/setupEdit',
    QUERY_CHARACTERIZATION_SETUP_UPDATE: '/rest/characterization/setupUpdate',
    QUERY_CHARACTERIZATION_GET_COLUMN_NAME_OPTIONS_BY_TYPE: '/rest/characterization/getColumnNameOptionsByType',
    QUERY_CHARACTERIZATION_GET_COLUMN_VALUE_UNIT_OPTIONS: '/rest/characterization/getColumnValueUnitOptions',
    QUERY_CHARACTERIZATION_GET_ASSAY_TYPES_BY_CHAR_NAME: '/rest/characterization/getAssayTypesByCharName',
    QUERY_CHARACTERIZATION_GET_CHAR_PROPERTIES: '/rest/characterization/getCharProperties',
    QUERY_CHARACTERIZATION_GET_CHAR_NAMES_BY_CHAR_TYPE: '/rest/characterization/getCharNamesByCharType',
    QUERY_CHARACTERIZATION_REMOVE: '/rest/characterization/removeCharacterization',
    QUERY_CHARACTERIZATION_REMOVE_FILE: '/rest/characterization/removeFile',
    QUERY_CHARACTERIZATION_REMOVE_FINDING: '/rest/characterization/removeFinding',
    QUERY_CHARACTERIZATION_REMOVE_EXPERIMENT: '/rest/characterization/removeExperimentConfig',
    QUERY_CHARACTERIZATION_GET_INSTRUMENT_TYPES_BY_TECHNIQUE: '/rest/characterization/getInstrumentTypesByTechniqueType',
    QUERY_CHARACTERIZATION_SET_COLUMN_ORDER: '/rest/characterization/setColumnOrder',
    QUERY_CHARACTERIZATION_SAVE_FILE: '/rest/characterization/saveFile',
    QUERY_CHARACTERIZATION_SAVE_FINDING: '/rest/characterization/saveFinding',
    QUERY_CHARACTERIZATION_SAVE_EXPERIMENT: '/rest/characterization/saveExperimentConfig',
    QUERY_CHARACTERIZATION_GET_DATUM_NUMBER_MODIFIER: '/rest/characterization/getDatumNumberModifier',
    QUERY_CHARACTERIZATION_SAVE: '/rest/characterization/saveCharacterization',
    QUERY_CHARACTERIZTAION_UPDATE_FINDING: '/rest/characterization/updateDataConditionTable',
    QUERY_CHARACTERIZATION_EXPORT_XLS: '/rest/sample/exportCharacterizationView',
    QUERY_CHEMICAL_ASSOCIATION_SAVE_FILE: '/rest/chemicalAssociation/saveFile',
    QUERY_CHEMICAL_ASSOCIATION_REMOVE_FILE: '/rest/chemicalAssociation/removeFile',
    QUERY_CHEMICAL_ASSOCIATION_EDIT: '/rest/chemicalAssociation/edit',
    QUERY_CHEMICAL_ASSOCIATION_GET_COMPOSING_ELEMENTS_BY_NANO_ID: '/rest/chemicalAssociation/getComposingElementsByNanomaterialEntityId',
    QUERY_CHEMICAL_ASSOCIATION_DELETE: '/rest/chemicalAssociation/delete',
    QUERY_CHEMICAL_ASSOCIATION_SAVE: '/rest/chemicalAssociation/submit',
    QUERY_CHEMICAL_ASSOCIATION_SETUP: '/rest/chemicalAssociation/setup',
    QUERY_CHEMICAL_ASSOCIATION_GET_ASSOCIATED_ELEMENT_OPTIONS: '/rest/chemicalAssociation/getAssociatedElementOptions',
    QUERY_COMPOSITION_SUMMARY_VIEW: '/rest/composition/summaryView',
    QUERY_COMPOSITION_FILE_SETUP: '/rest/compositionFile/setup',
    QUERY_COMPOSITION_FILE_EDIT: '/rest/compositionFile/edit',
    QUERY_COMPOSITION_FILE_DELETE: '/rest/compositionFile/delete',
    QUERY_COMPOSITION_FILE_SAVE: '/rest/compositionFile/submit',
    QUERY_COMPOSITION_EXPORT_XLS: '/rest/composition/summaryExport',

    QUERY_SYNTHESIS_SUMMARY_VIEW: '/rest/synthesis/summaryView',

    QUERY_SYNTHESIS_MATERIAL_SETUP: '/rest/synthesisMaterial/setup',
    QUERY_SYNTHESIS_MATERIAL_EDIT: '/rest/synthesisMaterial/edit',
    QUERY_SYNTHESIS_MATERIAL_DELETE: '/rest/synthesisMaterial/delete',
    QUERY_SYNTHESIS_MATERIAL_UPDATE: '/rest/synthesisMaterial/submit',
    SAVE_MATERIAL_ELEMENT: '/rest/synthesisMaterial/saveSynthesisMaterialElement',
    QUERY_SYNTHESIS_MATERIAL_SAVE_FILE: '/rest/synthesisMaterial/saveFile',
    QUERY_SYNTHESIS_MATERIAL_REMOVE_FILE: '/rest/synthesisMaterial/removeFile',

    QUERY_SYNTHESIS_FUNCTIONALIZATION_SETUP: '/rest/synthesisFunctionalization/setup',
    QUERY_SYNTHESIS_FUNCTIONALIZATION_EDIT: '/rest/synthesisFunctionalization/edit',
    QUERY_SYNTHESIS_FUNCTIONALIZATION_DELETE: '/rest/synthesisFunctionalization/delete',
    QUERY_SYNTHESIS_FUNCTIONALIZATION_UPDATE: '/rest/synthesisFunctionalization/submit',
    SAVE_FUNCTIONALIZATION_ELEMENT: '/rest/synthesisFunctionalization/saveMaterialElement',
    QUERY_SYNTHESIS_FUNCTIONALIZATION_SAVE_FILE: '/rest/synthesisFunctionalization/saveFile',
    QUERY_SYNTHESIS_FUNCTIONALIZATION_REMOVE_FILE: '/rest/synthesisFunctionalization/removeFile',

    QUERY_SYNTHESIS_PURIFICATION_SETUP: '/rest/synthesisPurification/setup',
    QUERY_SYNTHESIS_PURIFICATION_EDIT: '/rest/synthesisPurification/setupEdit',
    QUERY_SYNTHESIS_PURIFICATION_DELETE: '/rest/synthesisPurification/deletePurification',
    QUERY_SYNTHESIS_PURIFICATION_UPDATE: '/rest/synthesisPurification/submit',
    QUERY_SYNTHESIS_PURIFICATION_SAVE_FILE: '/rest/synthesisPurification/saveFile',
    QUERY_SYNTHESIS_PURIFICATION_REMOVE_FILE: '/rest/synthesisPurification/removeFile',
    QUERY_SYNTHESIS_PURIFICATION_INSTRUMENT_TYPES: '/rest/synthesisPurification/getInstrumentTypesByTechniqueType',
    QUERY_SYNTHESIS_PURIFICATION_GET_DATUM_NUMBER_MODIFIER: '/rest/synthesisPurification/getDatumNumberModifier',
    QUERY_SYNTHESIS_NEW_FINDING: '/rest/synthesisPurification/newPurity',
    QUERY_SYNTHESIS_SAVE_FINDING: '/rest/synthesisPurification/createPurity',
    QUERY_SYNTHESIS_UPDATE_FINDING: '/rest/synthesisPurification/updatePurity',
    QUERY_SYNTHESIS_REMOVE_FINDING: '/rest/synthesisPurification/deletePurity',

    QUERY_SYNTHESIS_GET_COLUMN_NAME_OPTIONS_BY_TYPE: '/rest/synthesisPurification/getColumnNameOptionsByType',
    QUERY_SYNTHESIS_GET_COLUMN_VALUE_UNIT_OPTIONS: '/rest/synthesisPurification/getColumnValueUnitOptions',
    QUERY_SYNTHESIS_GET_CONDITION_PROPERTY_OPTIONS: '/rest/synthesisPurification/getConditionPropertyOptions',
    QUERY_SYNTHESIS_SET_COLUMN_ORDER: '/rest/synthesisPurification/setColumnOrder',

    QUERY_FUNCTIONALIZING_ENTITY_SAVE_FILE: '/rest/functionalizingEntity/saveFile',
    QUERY_FUNCTIONALIZING_ENTITY_REMOVE_FILE: '/rest/functionalizingEntity/removeFile',
    QUERY_FUNCTIONALIZING_ENTITY_REMOVE_FUNCTION: '/rest/functionalizingEntity/removeFunction',
    QUERY_FUNCTIONALIZING_ENTITY_SAVE_FUNCTION: '/rest/functionalizingEntity/saveFunction',
    QUERY_FUNCTIONALIZING_ENTITY_EDIT: '/rest/functionalizingEntity/edit',
    QUERY_FUNCTIONALIZING_ENTITY_SETUP: '/rest/functionalizingEntity/setup',
    QUERY_FUNCTIONALIZING_ENTITY_DELETE: '/rest/functionalizingEntity/delete',
    QUERY_FUNCTIONALIZING_ENTITY_SAVE: '/rest/functionalizingEntity/submit',
    QUERY_ADD_FAVORITE: '/rest/core/addFavorite',
    QUERY_GET_FAVORITE: '/rest/core/getFavorites',
    QUERY_GET_WORKSPACE: '/rest/core/getWorkspaceItems',
    QUERY_DELETE_FAVORITE: '/rest/core/deleteFavorite',
    HELP_URL_FAVORITE: 'https://wiki.nci.nih.gov/x/b4AnEQ',
    HELP_URL_WORKSPACE: 'https://wiki.nci.nih.gov/x/fYQfEQ',
    HELP_URL_WORKFLOW: 'https://wiki.nci.nih.gov/x/GIIyHg',
    // Publications top menu
    HELP_URL_PUBLICATIONS: 'https://wiki.nci.nih.gov/x/e4QfEQ',
    HELP_URL_CREATE_PUBLICATIONS: 'https://wiki.nci.nih.gov/x/kIFDHg',
    HELP_URL_EDIT_PUBLICATIONS: 'https://wiki.nci.nih.gov/x/koFDHg',
    HELP_URL_VIEW_PUBLICATIONS: 'https://wiki.nci.nih.gov/x/koFDHg',

    // Publications within sample
    HELP_URL_SAMPLE_PUBLICATIONS: 'https://wiki.nci.nih.gov/x/nYFDHg',
    HELP_URL_SAMPLE_SEARCH_BY_PUBLICATIONS: 'https://wiki.nci.nih.gov/x/mIFDHg',
    HELP_URL_SAMPLE_SEARCH_BY_PUBLICATIONS_RESULTS: 'https://wiki.nci.nih.gov/x/qIFDHg',
    HELP_URL_SAMPLE_CHARACTERIZATION: 'https://wiki.nci.nih.gov/x/eoQfEQ',
    HELP_URL_SAMPLE_COMPOSITION: 'https://wiki.nci.nih.gov/x/eYQfEQ',
    HELP_URL_SAMPLE_COMPOSITION_NANOMATERIAL: 'https://wiki.nci.nih.gov/x/toNDHg',
    HELP_URL_SAMPLE_COMPOSITION_FUNCTIONALIZING: 'https://wiki.nci.nih.gov/x/uINDHg',
    HELP_URL_SAMPLE_COMPOSITION_CHEMICAL_ASSOCIATION: 'https://wiki.nci.nih.gov/x/uoNDHg',
    HELP_URL_SAMPLE_COMPOSITION_COMPOSITION_FILE: 'https://wiki.nci.nih.gov/x/4INDHg',

    HELP_URL_KEYWORD_SEARCH_RESULTS: 'https://wiki.nci.nih.gov/x/NIKAEQ',

    HELP_URL_SAMPLE_SEARCH: 'https://wiki.nci.nih.gov/x/jIS8HQ',
    HELP_URL_SAMPLE_SEARCH_RESULTS: 'https://wiki.nci.nih.gov/x/kYS8HQ',
    HELP_URL_SAMPLE_COPY: 'https://wiki.nci.nih.gov/x/14S8HQ',

    HELP_URL_SAMPLE_CREATE: 'https://wiki.nci.nih.gov/x/gIS8HQ',
    HELP_URL_SAMPLE_EDIT: 'https://wiki.nci.nih.gov/x/goS8HQ',
    HELP_URL_SAMPLE_VIEW: 'https://wiki.nci.nih.gov/x/goS8HQ',
    HELP_URL_SAMPLE_ADVANCED_SEARCH: 'https://wiki.nci.nih.gov/x/joS8HQ',

    HELP_URL_PUBLICATION_SEARCH: 'https://wiki.nci.nih.gov/x/loFDHg',
    HELP_URL_PUBLICATION_SEARCH_RESULTS: 'https://wiki.nci.nih.gov/x/pYFDHg',

    HELP_URL_PROTOCOL_SEARCH: 'https://wiki.nci.nih.gov/x/TYFDHg',
    HELP_URL_PROTOCOL_MANAGE: 'https://wiki.nci.nih.gov/x/eIQfEQ',
    HELP_URL_PROTOCOL_CREATE: 'https://wiki.nci.nih.gov/x/SIFDHg',
    HELP_URL_PROTOCOL_EDIT: 'https://wiki.nci.nih.gov/x/S4FDHg',
    HELP_URL_PROTOCOL_VIEW: 'https://wiki.nci.nih.gov/x/S4FDHg',
    HELP_URL_PROTOCOL_SEARCH_RESULTS: 'https://wiki.nci.nih.gov/x/VoFDHg',

    // Mi TODO: change this to real link
    HELP_URL_SAMPLE_SYNTHESIS: 'https://wiki.nci.nih.gov/display/caNanoLab/Managing+Samples+in+caNanoLab#ManagingSamplesincaNanoLab-EditSample',
    HELP_URL_CURATION: 'https://wiki.nci.nih.gov/x/uoGAEQ',
    HELP_URL_GROUPS_CURATOR: 'https://wiki.nci.nih.gov/x/fIQfEQ',
    HELP_URL_GROUPS_RESEARCHER: 'https://wiki.nci.nih.gov/x/a4ZDHg',

    HELP_URL_CURATION_REVIEW_DATA_PENDING_RELEASE: 'https://wiki.nci.nih.gov/x/UoZDHg',
    HELP_URL_CURATION_MANAGE_BATCH_DATA: 'https://wiki.nci.nih.gov/x/VIZDHg',
}

export enum SortState{
    NO_SORT,
    SORT_UP,
    SORT_DOWN
}

export enum ProtocolScreen{
    PROTOCOL_SEARCH_RESULTS_SCREEN,
    PROTOCOL_SEARCH_INPUT_SCREEN,
    PROTOCOL_EDIT_SCREEN,
    PROTOCOL_VIEW_SCREEN,
}

export enum SampleScreen{
    SAMPLE_SEARCH_RESULTS_SCREEN,
    SAMPLE_SEARCH_INPUT_SCREEN,
    SAMPLE_MANAGE_SCREEN,
    SAMPLE_EDIT_SCREEN,
    SAMPLE_VIEW_SCREEN,
}
